
import React from 'react'
import "../Styles/Card.css"



export const Card = () => {
    return (
        <div className='main_container'>
            <div className="img_container">
                <img className='imgg' src="https://wallpapercave.com/wp/wp3782998.jpg" alt="" />
            </div>
            <h1>Luxury Resorts in India</h1>
            <div className="card_body">
                <div>
                    <img className='rest' src="https://media-cdn.tripadvisor.com/media/photo-s/29/0b/3f/18/exterior.jpg" alt=''/>
                    <h2> Le Méridien Jaipur Resort & Spa </h2>
                    <p>The service given by housekeeping staff Mr Deepak mr chandrpal Mr Mahendra is very good</p>
                </div>
                <div>
                <img className='rest' src="https://dynamic-media-cdn.tripadvisor.com/media/photo-o/29/aa/59/6c/luxury.jpg?w=400&h=-1&s=1%201x,https://dynamic-media-cdn.tripadvisor.com/media/photo-o/29/aa/59/6c/luxury.jpg?w=800&h=-1&s=1%202x%22" alt='' />
                <h2> DATA Resort by Della Adventure </h2>
                    <p>The service given by housekeeping staff Mr Deepak mr chandrpal Mr Mahendra is very good</p>
                
                </div>
                <div>
                <img className='rest' src="https://media-cdn.tripadvisor.com/media/photo-s/23/56/ef/3f/kaldan-samudhra.jpg" alt=''/>
                <h2> Kaldan Samudhra Palace </h2>
                    <p>The service given by housekeeping staff Mr Deepak mr chandrpal Mr Mahendra is very good</p>
                </div>
                <div>
                <img className='rest' src="https://media-cdn.tripadvisor.com/media/photo-s/03/c5/40/94/the-corinthians-boutique.jpg" alt=''/>
                <h2> The Corinthians Resort & Club </h2>
                    <p>The service given by housekeeping staff Mr Deepak mr chandrpal Mr Mahendra is very good</p>
                </div>
                <div>
                <img className='rest' src="https://media-cdn.tripadvisor.com/media/photo-s/05/db/ce/fc/kiyan-pathway.jpg" alt=''/>
                <h2> Wild Planet Resort </h2>
                    <p>The service given by housekeeping staff Mr Deepak mr chandrpal Mr Mahendra is very good</p>
                </div>
                <div>
                <img className='rest'  src="https://media-cdn.tripadvisor.com/media/photo-s/21/f4/6a/45/facade.jpg" alt='' />
                <h2> Radisson Resort & Spa Lonavala </h2>
                    <p>The service given by housekeeping staff Mr Deepak mr chandrpal Mr Mahendra is very good</p>
                </div>
              
            </div>
           

           

            
        </div>
    )
}

export default Card;